import React from "react";
import { Link } from "react-router-dom";
import { FaCogs, FaDownload, FaLayerGroup } from "react-icons/fa";

function CommissionsHeader({
  onExport,
  loading,
  showInquiryBatches = false,
  showAutomationRules = false,
}) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="min-w-0">
        <h1 className="text-xl font-bold leading-tight text-[#35314d] sm:text-2xl">
          Commissions Management
        </h1>
        <p className="mt-0.5 text-[13px] leading-snug text-gray-500">
          Monitor commission status across education and migration applications
        </p>
      </div>
      <div className="flex w-full shrink-0 flex-wrap items-center justify-start gap-2 sm:w-auto sm:justify-end">
        {showInquiryBatches ? (
          <Link
            to="/commissions/inquiry-batches"
            className="inline-flex items-center gap-1.5 rounded-md border border-violet-200 bg-violet-50 px-3 py-1.5 text-[13px] font-medium text-violet-700 transition hover:bg-violet-100"
            style={{ boxShadow: "none" }}
          >
            <FaLayerGroup size={13} />
            Inquiry Batches
          </Link>
        ) : null}
        {/*
          Automation rules — intentionally hidden on Commissionable Students for now.
          http://localhost:3000/commissions-invoices
        {showAutomationRules ? (
          <Link
            to="/commissions/status-rules"
            title="Configure what each application status does to commission"
            className="inline-flex items-center gap-1.5 rounded-md border border-gray-200 bg-white px-3 py-1.5 text-[13px] font-medium text-gray-700 transition hover:bg-gray-50"
            style={{ boxShadow: "none" }}
          >
            <FaCogs size={13} />
            Automation rules
          </Link>
        ) : null}
        */}
        <button
          type="button"
          onClick={onExport}
          disabled={loading}
          className="inline-flex items-center gap-1.5 rounded-md border border-[#007BFF]/40 bg-white px-3 py-1.5 text-[13px] font-medium text-[#007BFF] transition hover:bg-[#007BFF]/5 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <FaDownload size={13} />
          Export CSV
        </button>
      </div>
    </div>
  );
}

export default CommissionsHeader;
